<template>
    <div class="w-auto">
        <router-link :to="to" class="block px-2 py-1">
            <i class="fas fa-pen text-sm text-gray-500 hover:text-blue"></i>
        </router-link>
    </div>
</template>

<script>
    export default {
        props: ['to']
    }
</script>